<template>
  <transition name="slideUp">
    <div class="cookie" v-if="show">
      <div>
        <h4>Kami menghargai privasi kamu</h4>
        <p>Kami menggunakan cookie untuk kamu
          berselancar di website dengan pengalaman yang terbaik.
          Dengan klik Terima Semua Cookie kamu setuju dengan
          <a href="/privacy-policy">Kebijakan Privasi Team Up For Impact</a>.</p>
        </div>
      <div class="actionCnt">
        <button class="secondary" v-on:click="denyCookie">Tolak</button>
        <button v-on:click="acceptCookie">Terima Semua Cookie</button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      content: '',
      action: null,
      next: null,
      time: null,
    };
  },
  methods: {
    open(d, n) {
      this.next = n;
      this.show = true;
    },
    close(b) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b);
    },
    denyCookie() {
      localStorage.setItem('cookie', 'y');
      this.close(false);
    },
    acceptCookie() {
      localStorage.setItem('cookie', 'y');
      localStorage.setItem('cookieAccepted', 'y');
      this.close(true);
    },
  },
};
</script>

<style scoped lang="scss">
.cookie{
  position: fixed;
  left: 0; right: 0; bottom: 0;
  border-top: #eee 1px solid;
  box-shadow: 0 0 6px rgba(0, 0, 0, .1);
  background-color: #fff;
  color: #444;
  padding: 20px 20px;
  z-index: 999;
  display: flex;
  align-items: center;
  @media (max-width: 860px) {
    display: block;
    text-align: center;
  }
  h4{
    font-family: 'GolosUIWebBold', sans-serif;
    font-size: 18px;
    margin: 0 0 4px;
    @media (max-width: 680px) {
      font-size: 16px;
    }
  }
  p{
    margin: 0;
    font-size: 15px;
    @media (max-width: 680px) {
      font-size: 13px;
    }
  }
  .actionCnt{
    margin-left: auto;
    white-space: nowrap;
    @media (max-width: 860px) {
      margin-top: 14px;
    }
    button{
      margin-left: 10px;
      @media (max-width: 680px) {
        padding: 8px 10px;
        font-size: 16px;
      }
      &.secondary{
        margin-left: 20px;
        border-color: #fff;
      }
    }
  }
}
</style>
